module.exports = {
   
clientId: 1,
 "default_login" : "",
    "default_pass" : "",
    hexon: true,
    vehicle_details_show_special_button: true,
    hide_fix_damages: true,
    hide_picked_up: true,
    hide_sell_with_license_plate: true,
    hide_sales_preference: true,
    disable_SIRV:false,
    enable_hemex : true,
    hide_transport_card: true,
    hide_website_card : true,
    // hide_inspection_card : true,
    hide_photos_card : true,
    hide_other_buttons : true,
    hide_inspection_filter : true,
    hide_mandatory_field_outgoing_order : true,
    hide_transaction_result : true,
    hide_products : true ,
    hide_bpm_card : true ,
    hide_task_card : true,
    hide_rdw_card : true,
    hide_payment_filter : true,
    hide_company_structure_card: true,
    hide_counterscard: true,
    user_filter_list : [
        {
            label:'admin',
            value:1
        }
    ],

       google_maps_api_key: "AIzaSyAzQOd9IQpDtlFtrk8Cb_imsvHfeF-yDMk",

 requiredFieldsPersonal: [
          "empty_weight",
          "number_of_seats",
          "interior_color",
          "interior_type",
          "power_axle",
          "trailer_with_brakes",
          "middleaxle_trailer_with_brakes",
          "mileage",
          "brand_name",
          "model_name",
          "model_info",
          "date_first_allowance",
          "body_type",
          "base_color",
          "transmission_type",
          "fuel_type",
          "co2_rdw",
          "euro_class",
          "verbruik",
          "energy_label",
        ],

requiredFieldsCommercial : [
  "number_of_seats",
  "power_axle",
  "trailer_with_brakes",
  "middleaxle_trailer_with_brakes",
  "technical_max_weight_vehicle",
  "mileage",
  "brand_name",
  "model_name",
  "model_info",
  "date_first_allowance",
  "body_type",
  "base_color",
  "transmission_type",
  "fuel_type",
  "co2_rdw",
  "euro_class",
  "verbruik",
  "energy_label",
        ],

requiredFieldsElectric :[
  "battery_capacity",
  "consumption_KwH",
  "max_chargingspeed_DC",
],
        optionsList_inspectionPart1 : [
          {
              title: 'interieur',
          },
'Tellerklok',  
'DAB ontvanger',
  'Navigatiesysteem',
  'Apple carplay',
  'Android auto',
  'Virtual Cockpit',
  'Airco',
  'Autopilot',
  'Airco ECC',
  'Standkachel',
  'Voorklimatisering',
  'Cruise control',
  'Cruise control adaptief',
  'Luchtvering',
  'Head-up display',
  'Nachtzicht-assistent',
  'Rijstrooksensor',
  'Verkeersbord detectie',
  'Dodehoek detectie',
  'Achteruitrijcamera',
  'Camera voor',
  'Rondomzicht camera',
  'Parkeer assistent',
  'Keyless start',
  'Start/stop systeem',
  'autonome parkeerfunctie',
  'Elektrisch bedienbare cabriokap',
  'stoelverwarming voor',
  'Stuurverwarming',
  'Verwarmde voorruit',
  'stoel ventilatie voor',
        ],
        optionsList_inspectionPart2 : [
'Buitenspiegels elektrisch inklapbaar',
'Elektrische spiegels',
'Audio installatie premium',
'Hoogte verstelbare bestuurdersstoel',
'Elektrische verstelbare stoelen',
'Armsteun voor',
'Memory stoelen',
'Stoffen bekleding',
'Stof/alcantara bekleding',
'Alcantara bekleding',
'Lederen bekleding',
'Lederen/alcantara bekleding',
'Lederen/stof bekleding',
'Sportief interieur',
'Lederen sportstuur',
'Lederen stuur',
'Stuurwiel multifunctioneel',
'Schakelmogelijkheid stuurwiel',
'Zwarte hemelbekleding',
'Schuif-kanteldak',
'Panoramadak',
'Keyless entry',
'Achter interieur',
'Voor interieur',
'Achterbank armsteun',
'Isofix bevestiging',
'Achterbank verwarmd',
'stoel ventilatie achter',
'Airco separaat achter',
{
              title: 'exterieur',
          },
'LED achterlichten',
'Parkeersensor achter',
'Metallic lak',
'Two-tone (metaal) kleur',
'Dakrails',
'Getint glas',
'Kofferruimte',
'Elektrisch bedienbare achterklep',
'Trekhaak met vaste kogel',
'Trekhaak met afneembare kogel',
'Trekhaak wegklapbare kogel',
],
      optionsList_inspectionPart3 : [
  
'derde zitrij',
'Hoogte verstelling passagiersstoel',
'Lichtmetalen velgen',
'Buitenspiegels carrosseriekleur',
'Sportpakket',
'Bi-xenon koplampen',
'Laser LED koplampen',
'LED koplampen',
'Xenon koplampen',
'Halogeen koplampen',
'Parkeersensor voor',
'Cabriolet kap',
  ],

  optionsList_inspectionPart4 : [
    {
      title: 'Bedrijfswagen',
  },
'Sidebars',
'Treeplanken',
'Zijschuifdeur links',
'Bullbar',
'Zijschuifdeur rechts',
'Elektrische schuifdeur',
'Dubbele cabine',
'Achterdeuren',
'Achterklep',
'Laadlift',
'Laadbak',
'Koelwagenuitvoering',
'Houtvloer',
'Betimmering laadruimte',
'Tussenschot',
'Kastindeling',
],

 photo_layers: {
      //put these images in the same directory as where /documents are stored
      top: ['top1.png'],
      bottom: ['bottom1.png', 'bottom2.png', 'bottom3.png'],
    },

    inspection_impressions: true,
    inspection_attention_incidents: true,
    inspection_v2: true,
    auth_flow: 'AZURE',
    azure_client_id: '3a5af465-4bcd-45dd-8f07-f9e7c7216831',
    azure_authority: 'https://indewal.b2clogin.com/indewal.onmicrosoft.com/B2C_1_SignUpAndSignIn',
    azure_authority_domain: 'indewal.b2clogin.com',
    azure_domain: 'indewal.onmicrosoft.com',
    azure_auth_policy: 'B2C_1_SignUpAndSignIn',
    azure_redirect_uri: '/',
    azure_logout_redirect_uri: 'https://vindat.indewal.nl',

 pusherKey: 'a49d2ef49501c555456a',
};
